
import { WidgetConstants } from './layout/widget-constants';
import {
  CardLayoutWidgetPlaceHolderConfigParams, CategoryGroupTilesWidgetPlaceHolderConfigParams,
  CheckoutWidgetPlaceHolderConfigParam, MyInvoiceDetailWidgetPlaceHolderConfigParams,
  MyInvoiceWidgetPlaceHolderConfigParams, NewsListWidgetConfigParams,
  ProductDetailsWidgetConfigParams, ProductListDisplayWidgetPlaceHolderConfigParams,
  ProductSliderWidgetPlaceHolderConfigParams, ShippingAddressAddWidgetConfigParams,
  ShippingAddressDetailsWidgetConfigParams, ShippingAddressWidgetConfigParams,
  ShoppingCartWidgetConfigParams, StaticPageWidgetConfigParams, VoucherListWidgetConfigParams
} from './layout/widgets-config.model';

// tslint:disable-next-line:no-namespace
export namespace CpCommerceConstants {
  export enum MenuLists {
    TOP_MENU = 'TOP_MENU',
    BOTTOM_MENU = 'BOTTOM_MENU',
    LEFT_SIDE_MENU = 'LEFT_SIDE_MENU',
    USER_MENU = 'USER_MENU',
  }

  export const MenuItems = [
    { component: 'Home', route: 'home', menu_icon: 'home' },
    { component: 'Products', route: 'product-category-list', menu_icon: 'cart-sharp' },
    { component: 'Products V2', route: 'page/product-category-list', menu_icon: 'cart-sharp' },
    { component: 'Products Details V2', route: 'page/product-details', menu_icon: 'cart-sharp' },
    { component: 'Products Comparison V2', route: 'page/product-comparison', menu_icon: 'cart-sharp' },
    { component: 'Products Display V2', route: 'page/product-display', menu_icon: 'cart-sharp' },
    { component: 'News', route: 'news-list', menu_icon: 'newspaper-outline' },
    { component: 'News V2', route: 'page/news-list', menu_icon: 'newspaper-outline' },
    { component: 'Store Locator', route: 'store-locator-list', menu_icon: 'location-sharp' },
    { component: 'Store Locator V2', route: 'page/store-locator-list', menu_icon: 'location-sharp' },
    { component: 'Sign In', route: 'login', menu_icon: 'log-out-outline' },
    { component: 'My Wishlist', route: 'my-wishlist', menu_icon: 'heart' },
    { component: 'My Wishlist V2', route: 'page/my-wishlist', menu_icon: 'heart' },
    { component: 'Account', route: 'home', menu_icon: 'person' },
    { component: 'Logout', route: 'login', menu_icon: 'log-out-outline' },
    { component: 'Cart', route: 'cart', menu_icon: 'cart' },
    { component: 'Checkout V2', route: 'page/checkout-step-v2', menu_icon: 'cart' },
    { component: 'Checkout Senheng', route: 'page/checkout-step-senheng', menu_icon: 'cart' },
    { component: 'E Invoice', route: 'page/e-invoice', menu_icon: 'reader' },
    { component: 'Edit Profile', route: 'profile1', menu_icon: 'person' },
    { component: 'My Order History', route: 'my-sales-orders', menu_icon: 'reader' },
    { component: 'My Order History V2', route: 'page/my-sales-orders', menu_icon: 'reader' },
    { component: 'My Invoice History', route: 'my-invoice-history', menu_icon: 'reader' },
    { component: 'My Invoice History V2', route: 'page/my-invoice-history', menu_icon: 'reader' },
    { component: 'My Rewards', route: 'reward-list', menu_icon: 'gift' },
    { component: 'My Rewards V2', route: 'page/my-rewards', menu_icon: 'gift' },
    { component: 'My Vouchers', route: 'voucher-list', menu_icon: 'gift' },
    { component: 'My Vouchers V2', route: 'page/my-vouchers', menu_icon: 'gift' },
    { component: 'My Addresses', route: 'my-shipping-address', menu_icon: 'cart' },
    { component: 'My Addresses V2', route: 'page/my-shipping-address', menu_icon: 'cart' },
    { component: 'My Membership', route: 'my-membership', menu_icon: 'card' },
    { component: 'My Membership V2', route: 'page/my-membership', menu_icon: 'card' },
    { component: 'My Shipment Tracker', route: 'page/shipment-tracker', menu_icon: 'bus' },
    { component: 'My Payment Methods', route: 'page/my-payment-methods', menu_icon: 'card' },
    { component: 'Country Selector', route: 'page/country-selector', menu_icon: 'location-sharp' },

    { component: 'Privacy Policy', route: 'static-page/PRIVACY', menu_icon: 'reader' },
    { component: 'Returns and Refunds', route: 'static-page/RETURNS_AND_REFUNDS', menu_icon: 'cash' },
    { component: 'Contact Us', route: 'static-page/CONTACT_US', menu_icon: 'call' },
    { component: 'Delivery', route: '/static-page/DELIVERY', menu_icon: 'car-outline' },
    { component: 'Terms and Conditions', route: '/static-page/TERMS-AND-CONDITIONS', menu_icon: 'reader' },
    { component: 'About Us', route: '/static-page/ABOUT-US', menu_icon: 'reader' },

    { component: 'Sales Quotation', route: 'sales-quotation', menu_icon: 'reader' },
    { component: 'News & Events', route: 'article', menu_icon: 'icon-Discount-Original' },
    { component: 'Games', route: 'games', menu_icon: 'icon-Games' },
    { component: 'Rewards', route: 'rewards', menu_icon: 'icon-Gift-Original' },
    { component: 'Customer Support', route: 'support', menu_icon: 'icon-Support-Agent' },
    { component: 'Carrers', route: 'carrers', menu_icon: 'icon-Job-Seeker-Original' },
    { component: 'Payment Channels', route: 'services/payment-channels', menu_icon: 'icon-Card-Payment-Original' },
    { component: 'Partnership Program', route: 'partnership', menu_icon: 'icon-Hand-Shake-Original' },
    { component: 'Reseller', route: 'reseller', menu_icon: 'icon-Reseller-Original' },
    { component: 'Card Layout Widget', route: 'page/our-services', menu_icon: 'reader' },
  ];

  export class WidgetConfigBase {
    constructor(private widgetPlaceHolderId: string, private model: any = null) { }

    getPlaceHolderId = () => this.widgetPlaceHolderId;
    getModel = () => this.model;

    /**TODO: Retrieves all properties (and datatype) of the injected model */
    getParams() {

    }
  }

  export const WidgetConfigs = [
    new WidgetConfigBase(WidgetConstants.widgetIdList.SLIDER),
    new WidgetConfigBase(WidgetConstants.widgetIdList.NAV),
    new WidgetConfigBase(WidgetConstants.widgetIdList.HEADER),
    new WidgetConfigBase(WidgetConstants.widgetIdList.FOOTER),
    new WidgetConfigBase(WidgetConstants.widgetIdList.REWARDS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.ORDER_LISTING),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MEMBERSHIP),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PRODUCT_SLIDER, ProductSliderWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PRODUCT_LIST, ProductListDisplayWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PRODUCT_DETAILS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.CHECKOUT_STEP_V2, CheckoutWidgetPlaceHolderConfigParam),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_INVOICE, MyInvoiceWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_INVOICE_DETAIL, MyInvoiceDetailWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_INVOICE_ITEM_DETAIL),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PRODUCT_CATEGORY),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_VOUCHERS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_VOUCHERS_DETAILS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.STORE_SELECTOR),
    new WidgetConfigBase(WidgetConstants.widgetIdList.CARD_LAYOUT_WIDGET, CardLayoutWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MONALIZA_HOME),
    new WidgetConfigBase(WidgetConstants.widgetIdList.POST_DISPLAY),
    new WidgetConfigBase(WidgetConstants.widgetIdList.COUNTDOWN_TIMER), // ADDING THE DATE PARAMETER
    new WidgetConfigBase(WidgetConstants.widgetIdList.WELCOME_HEADER), // ADD PARAMETERS LATER
    new WidgetConfigBase(WidgetConstants.widgetIdList.VERTICAL_MENU), // ADD PARAMETERS LATER
    new WidgetConfigBase(WidgetConstants.widgetIdList.TAB_MENU), // ADD PARAMETERS LATER
    new WidgetConfigBase(WidgetConstants.widgetIdList.CLICKNET_HEADER), // ADD PARAMETERS LATER
    new WidgetConfigBase(WidgetConstants.widgetIdList.GENERIC_HEADER), // ADD PARAMETERS LATER
    new WidgetConfigBase(WidgetConstants.widgetIdList.COUNTRY_SELECTOR), // ADD PARAMETERS LATER

    new WidgetConfigBase(WidgetConstants.widgetIdList.STATIC_PAGE_DISPLAY, StaticPageWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_SHIPPING_ADDRESS, ShippingAddressWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_SHIPPING_ADDRESS_ADD, ShippingAddressAddWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_SHIPPING_ADDRESS_DETAILS, ShippingAddressDetailsWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.NEWS_LIST, NewsListWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.NEWS_DETAILS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PROFILE),
    new WidgetConfigBase(WidgetConstants.widgetIdList.SHOPPING_CART, ShoppingCartWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.STORE_LOCATOR_DETAILS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.VOUCHER_DETAILS),
    new WidgetConfigBase(WidgetConstants.widgetIdList.VOUCHER_LIST, VoucherListWidgetConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.MY_WISHLIST),
    new WidgetConfigBase(WidgetConstants.widgetIdList.CATEGORIES, CategoryGroupTilesWidgetPlaceHolderConfigParams),
    new WidgetConfigBase(WidgetConstants.widgetIdList.PRODUCT_DETAILS, ProductDetailsWidgetConfigParams),
  ];

  export enum BlCmsWebSiteHdrConstants {
    ECOMSYNC_BY_BRANCH = 'ECOMSYNC_BY_BRANCH',
    PRICING_SCHEME = 'PRICING_SCHEME',
    ECOMSYNC_STOCK_SRC = 'ECOMSYNC_STOCK_SRC',
    MKP_STOCK_SRC = 'MKP_STOCK_SRC',
  }

  export enum StepperIndexConstants {
    SHOPPING_CART = '0',
    SHIPPING = '1',
    VOUCHERS = '2',
    MEMBERSHIP_POINT_CONVERSION = '3',
    PAYMENT = '4'
  }

  export enum BlCmsPostsConstants {
    THUMBNAIL_IMAGE_POST = 'THUMBNAIL_IMAGE_POST',
    CONTENT_IMAGE_POST = 'CONTENT_IMAGE_POST',
  }

  export enum BLCmsWebSideExtParamCodes {
    DEFAULT_MEMBERSHIP_CLASS = 'DEFAULT_MEMBERSHIP_CLASS',
    RECAPTCHA_SECRET_KEY = 'RECAPTCHA_SECRET_KEY',
    RECAPTCHA_SITE_KEY = 'RECAPTCHA_SITE_KEY',
    RECAPTCHA_IMPLEMENTATION = 'RECAPTCHA_IMPLEMENTATION',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_MENU_LISTS = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_MENU_LISTS',
    SYS_AKN_WEB_CP_COMMERCE_INTERNAL_SALES_ORDER_PRINTABLE_GUID = 'SYS_AKN_WEB_CP_COMMERCE_INTERNAL_SALES_ORDER_PRINTABLE_GUID',
    RESTRICT_BY_ENTITY = 'RESTRICT_BY_ENTITY',
    PUBLIC_CART = "PUBLIC_CART",
    WEBCHAT_VIRTUAL_URL = 'WEBCHAT_VIRTUAL_URL',
    WINDOWS_FIXED_WIDTH_VALUE = "WINDOWS_FIXED_WIDTH_VALUE",
    SYS_AKN_WEB_CP_COMMERCE_ENABLE_PICKUP_STORE = 'SYS_AKN_WEB_CP_COMMERCE_ENABLE_PICKUP_STORE',
    SYS_AKN_WEB_CP_COMMERCE_SHIPPING_PRICEBOOK = 'SYS_AKN_WEB_CP_COMMERCE_SHIPPING_PRICEBOOK',
    SYS_AKN_WEB_CP_COMMERCE_SHIPPING_SERVICE_ITEM = 'SYS_AKN_WEB_CP_COMMERCE_SHIPPING_SERVICE_ITEM',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_LAYOUT_ROUTING = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_LAYOUT_ROUTING',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_TOPIC_HDR = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_TOPIC_HDR',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_AUTHENTICATION_LAYOUT_ROUTING = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_AUTHENTICATION_LAYOUT_ROUTING',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_LOADER_CONFIGURATION = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_LOADER_CONFIGURATION',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_POPUP_BLOCKER_CONTENT = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_POPUP_BLOCKER_CONTENT',
    SYS_POST_REGISTRATION_CONFIG = 'SYS_POST_REGISTRATION_CONFIG',
    PGW_MERCHANT_GUID = 'PGW_MERCHANT_GUID',
    GOOGLE_LOGIN_CONFIG = 'GOOGLE_LOGIN_CONFIG',
    FACEBOOK_LOGIN_CONFIG = 'FACEBOOK_LOGIN_CONFIG',
    APPLE_LOGIN_CONFIG = 'APPLE_LOGIN_CONFIG',
    META_DESCRIPTION = 'META_DESCRIPTION',
    GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
    FACEBOOK_PIXEL = 'FACEBOOK_PIXEL',
    SYS_AKN_WEB_CP_COMMERCE_DEFAULT_TEMPLATE = 'SYS_AKN_WEB_CP_COMMERCE_DEFAULT_TEMPLATE',
    SYS_AKN_WEB_CP_COMMERCE_FAVICON = 'SYS_AKN_WEB_CP_COMMERCE_FAVICON',
    ENABLE_WEBSITE_PRELOADER = 'ENABLE_WEBSITE_PRELOADER',
    ENABLE_RESELLER_WEBSITE = 'ENABLE_RESELLER_WEBSITE',
    RESTRICT_NOTIFICATION_BY_MEMBER = 'RESTRICT_NOTIFICATION_BY_MEMBER',
    WEBSITE_PRIVACY_AGREMENT_DOC_HDR_GUID = 'WEBSITE_PRIVACY_AGREMENT_DOC_HDR_GUID',
    WEBSITE_TERMS_AND_CONDITIONS_AGREMENT_DOC_HDR_GUID = 'WEBSITE_TERMS_AND_CONDITIONS_AGREMENT_DOC_HDR_GUID',
    ENABLE_APP_VERSION_UPDATE_POPUP = 'ENABLE_APP_VERSION_UPDATE_POPUP',
    ANDROID_PLAYSTORE_URL = 'ANDROID_PLAYSTORE_URL',
    IOS_APPLE_STORE_URL = 'IOS_APPLE_STORE_URL',
    HIDE_BANNERS = "HIDE_BANNERS",
    HIDE_MENU_MANAGER = "HIDE_MENU_MANAGER",
    HIDE_LAYOUT_MANAGER = "HIDE_LAYOUT_MANAGER",
    HIDE_IMAGE_MANAGER = "HIDE_IMAGE_MANAGER",
    HIDE_PRODUCT_MANAGEMENT = "HIDE_PRODUCT_MANAGEMENT",
    HIDE_VOUCHER_MANAGEMENT = "HIDE_VOUCHER_MANAGEMENT",
    HIDE_EVENT_MANAGER = "HIDE_EVENT_MANAGER",
    HIDE_NOTIFICATION = "HIDE_NOTIFICATION",
    HIDE_SHIPPING = "HIDE_SHIPPING",
    HIDE_QR_CODE_MANAGER = "HIDE_QR_CODE_MANAGER",
    HIDE_ACTIVITY_MANAGER = "HIDE_ACTIVITY_MANAGER",
  }

  export enum BlFiMstBranchExtParamCodes {
    SYS_AKN_WEB_CP_COMMERCE_STORE_LOCATOR = 'SYS_AKN_WEB_CP_COMMERCE_STORE_LOCATOR'
  }

  export enum BlCrmMembershipExtParamCodes {
    SYS_AKN_WEB_CP_COMMERCE_MEMBERSHIP_CLASS = 'MEMBERSHIP_CLASS',
    SYS_AKN_WEB_CP_COMMERCE_MEMBERSHIP_MOBILE_PHONE = 'MEMBERSHIP_MOBILE_PHONE',
  }

  export enum QUERY_PARAMS {
    INVITE_TOKEN = 'invite-token',
    REDIRECT_TO = 'redirect_to',
    KEYWORD = 'keyword',
    CATEGORY_NAME = 'categoryName',
    PRICE_FROM = 'priceFrom',
    PRICE_TO = 'priceTo',
    ADDRESS_ID = 'address_id',
    ADDRESS_TYPE = 'addressType',
    STEPPER_TYPE = 'stepperType',
    PRODUCT_ID = 'product_id',
    CATEGORY_ID = 'category_id',
    CATEGORY_GROUP_ID = 'category_group_id',
    IMAGE_ID = 'image_id',
    AUDIO_ID = 'audio_id',
    VIDEO_ID = 'video_id',
    PDF_ID = 'pdf_id',
    CHECKOUT_STEP = 'checkoutStep',
    MY_INVOICE_PAYMENT_STEP = 'myInvoicePaymentStep',
    SALES_ORDER_ID = 'sales_order_id',
    ITEM_ID = 'item_id',
    DRIVE_ID = 'drive_id',
    POST_ID = 'post_id',
    STATE = 'state',
    ACTIVITY = 'activity_id',
    RECEIPT_ID = 'receipt_id',
    WARRANTY_REG_ID = 'warranty_reg_id',
    STORE_ID = 'store_id',
    CURRENT_AUTH_WIDGET_SCREEN = 'auth_widget_screen',
    INVOICE_ID = 'invoiceGuid',
    OTP_CODE_AUTH_WIDGET = 'code',
    REGISTRATION_KEY_AUTH_WIDGET = 'key',
    EMAIL_AUTH_WIDGET = 'email',
    CURRENT_RMA_WIDGET_SCREEN = 'rma_widget_screen',
    VOUCHER_ID = 'voucher_id',
    COUPON_LINE_ID = 'coupon_line_id',
    CALENDAR_EVENT_ID = 'calendar_event_id',
  }

  export enum MENU_ITEM_LINK {
    COMPONENT = 'COMPONENT',
    PAGE = 'PAGE',
    CONTENT_CATEGORY = 'CONTENT CATEGORY',
    EXTERNAL_LINK = 'EXTERNAL LINK',
    LAYOUT_INSTANCE_LINK = 'LAYOUT INSTANCE LINK',
    POST_GUID = "postGuid",
    POST_NAME = "postName",
    CATEGORY = "CATEGORY",
    LAYOUT_INSTANCE = "LAYOUT INSTANCE"
  }

  export enum EXTERNAL_LINK_TARGET_TYPE {
    BLANK = '_blank',
    SELF = '_self',
    PARENT = '_self',
    TOP = '_top',
    SYSTEM = '_system',
  }

  export enum MENU_BADGE_DISPLAY_TYPE {
    CART_SIZE = 'CART_SIZE',
    WISHLIST_SIZE = 'WISHLIST_SIZE',
    NOTIFICATION_SIZE = 'NOTIFICATION_SIZE'
  }

  export enum LAYOUT_INSTANCE_TYPE {
    ROUTABLE = 'ROUTABLE',
    SECTION = 'SECTION'
  }

  export enum POST_TYPE {
    PAGE = 'PAGE',
    POPUP = 'POPUP',
    LAYOUT_INSTANCE = 'LAYOUT INSTANCE',
    POP_ON_LAY_INST = 'POPUP ON LAYOUT INSTANCE'
  }

  export enum SOCIAL_MEDIAS {
    FACEBOOK = 'facebook',
    WHATSAPP = 'whatsapp',
    PINTEREST = 'pinterest',
    TWITTER = 'twitter',
    INSTAGRAM = 'instagram',
    ANY = 'ANY' // Not part of ngx-share-buttons
    // EMAIL = 'email',
    // MESSENGER = 'messenger',
    // LINE = 'line',
    // LINKEDIN = 'linkedin',
    // REDDIT = 'reddit',
    // TELEGRAM = 'telegram',
    // VIBER = 'viber',
  }

  export enum SHIPPING_FEE_OPTIONS_CODE {
    SHIPPING_PRICEBOOK = 'SHIPPING_PRICEBOOK',
    DELIVERY_CHARGES = 'DELIVERY_CHARGES',
    DELIVERY_CHARGES_COUNTRY = 'DELIVERY_CHARGES_COUNTRY',
    DELIVERY_CHARGES_REGION = 'DELIVERY_CHARGES_REGION'
  }

  export enum OcrReasonsToRejectMessage {
    REJECTED_OUTDATED_RECEIPT = 'You have uploaded an outdated receipt. Please submit the receipt within 5 days of purchase.',
    REJECTED_NON_RELATED_RECEIPT = 'You have uploaded a non-related receipts. Please submit official and original printed receipts of MEGA or BiO-LiFE product purchases from any retail store, pharmaceutical retail outlet, pharmacy and e-store.',
    REJECTED_DUPLICATED_RECEIPT = 'You have uploaded a duplicated receipt. Please upload a new receipt.',
    REJECTED_INCOMPLETE_DETAILS = 'You have uploaded a receipt with incomplete details. Please make sure the details eg. Pharmacy Name, receipt date, item description & price are shown clearly in the receipt image.',
    REJECTED_EXCEEDED_MONTHLY_SUBMISSION_LIMIT = 'You have exceeded the monthly receipt submission limit. Maximum seven (7) receipts are allowed for submission each month.',
    REJECTED_MULTIPLE_RECEIPTS = "You have uploaded more than 1 receipt in this submission. Please submit only 1 receipt for each upload."
  }

  export enum NOTIFICATION_PUBLISH_STATUS {
    PENDING = 'PENDING',
    SENT = 'SENT'
  }

  export enum GENERIC_RESOURCE_INSTANCE_CODE {
    MINIORANGE = 'MINIORANGE'
  }
}
